import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRAccessPermission } from '../models/vdr-access-permission.model';

export interface UpdateVDRPermissionsRequest {
    permissions: VDRAccessPermission[];
}

export const UpdateVDRPermissions = createAsyncThunk(
    'dataRoom/updatePermissions',
    async ({ permissions }: UpdateVDRPermissionsRequest, { getState }: any) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomPermissions`,
                permissions
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not update access permissions at the moment.',
                    'error'
                );
                throw new Error('Failed to update access permissions');
            }

            return response.data;
        } catch (error) {
            createNotification(
                'An error occurred while updating access permissions.',
                'error'
            );
            throw error;
        }
    }
);
